import { api, reLoadPage, token } from "./config";

let assetTypesCache = null;

export async function getAssetTypes() {
  if (assetTypesCache) {
    return { data: { data: assetTypesCache } };
  }

  return api
    .get("enums/asset-types", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: `Bearer ${localStorage.getItem("login")}`,
      },
    })
    .then((res) => {
      assetTypesCache = res?.data?.data ?? [];
      return res;
    })
    .catch((error) => {
      if (error.request?.status === 401) {
        reLoadPage();
      }
    });
}

export async function AllBags() {
  return api
    .get("assets", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: `Bearer ${localStorage.getItem("login")}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (error.request.status === 401) {
        reLoadPage();
      }
    });
}
export async function rial() {
  return api
    .get("assets?f[type]=1", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: `Bearer ${localStorage.getItem("login")}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (error.request.status === 401) {
        reLoadPage();
      }
    });
}
export async function tether() {
  return api
    .get("assets?f[type]=2", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: `Bearer ${localStorage.getItem("login")}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (error.request.status === 401) {
        reLoadPage();
      }
    });
}
export async function gold() {
  return api
    .get("assets?f[type]=3", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: `Bearer ${localStorage.getItem("login")}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (error.request.status === 401) {
        reLoadPage();
      }
    });
}
export async function currency() {
  return api
    .get("assets?f[type]=4", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: `Bearer ${localStorage.getItem("login")}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (error.request.status === 401) {
        reLoadPage();
      }
    });
}
export async function investment() {
  return api
    .get("assets?f[type]=5", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: `Bearer ${localStorage.getItem("login")}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (error.request.status === 401) {
        reLoadPage();
      }
    });
}
export async function goldMelted() {
  return api
    .get("assets?f[type]=6", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: `Bearer ${localStorage.getItem("login")}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (error.request.status === 401) {
        reLoadPage();
      }
    });
}
export async function goldCoin() {
  return api
    .get("assets?f[type]=7", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: `Bearer ${localStorage.getItem("login")}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (error.request.status === 401) {
        reLoadPage();
      }
    });
}

// دریافت wallets بر اساس type
export async function getWalletsByType(type) {
  return api
    .get(`assets?f[type]=${type}`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: `Bearer ${localStorage.getItem("login")}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (error.request.status === 401) {
        reLoadPage();
      }
    });
}

export async function rialId(id) {
  return api
    // .get(`assets?f[type]=1&f[id]=${id}`, {
      .get(`assets?f[type]=${id}`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: `Bearer ${localStorage.getItem("login")}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (error.request.status === 401) {
        reLoadPage();
      }
    });
}
